import { render, staticRenderFns } from "./SkinCare.vue?vue&type=template&id=7e5db27c&scoped=true&"
import script from "./SkinCare.vue?vue&type=script&lang=js&"
export * from "./SkinCare.vue?vue&type=script&lang=js&"
import style0 from "./SkinCare.vue?vue&type=style&index=0&id=7e5db27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5db27c",
  null
  
)

export default component.exports